import * as angular from 'angular';
import * as _ from 'lodash';

import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsEvents} from "../../shared/dto/aps.events";
import {Strings} from "../../shared/config/constant.module";
import {StateParams} from "../../common";
import DateUtilityService from "../../services/utility/dateutility.service";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import CheckListInstancesServiceName, {CheckListInstancesService} from "../../services/checkLists/checkListInstances.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import CheckListInstancesHubName, {CheckListInstancesHub, CheckListInstancesHubCreator} from "../../services/checkLists/checkListInstances.hub";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import CheckListReportDetailsName, {openCheckListReportDetails} from "./checkListReportDetails.controller";

let requires = [CheckListReportDetailsName, CheckListsServiceName, CheckListInstancesServiceName, LoaderServiceName,
  CheckListInstancesHubName, ShopServiceName];

interface FailedChecksController {
  failedCheckLists: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;
  formatTime(time): string;
  open(checkListInstance: apsViewModels.CheckListInstanceListItem);
}

class FailedChecksCtrl implements FailedChecksController {
  failedCheckLists: apsViewModels.CheckListInstanceListItem[];
  loading: boolean;

  private plantId: string;
  private shopId: string;
  private timeZoneId: string;
  private checkListsService: CheckListsService;
  private checkListInstancesService: CheckListInstancesService;
  private loaderService: LoaderService;
  private hub: CheckListInstancesHub;
  private $modal: mm.foundation.modal;
  private $scope: angular.IScope;
  private $timeout: angular.ITimeoutService;
  private $q: angular.IQService;

  constructor(
    checkListsService: CheckListsService,
    checkListInstancesService: CheckListInstancesService,
    shopService: ShopService,
    loaderService: LoaderService,
    checkListInstancesHubCreator: CheckListInstancesHubCreator,
    $modal: mm.foundation.modal,
    $scope: angular.IScope,
    $timeout: angular.ITimeoutService,
    $q: angular.IQService,
    $stateParams: StateParams) {

    this.loading = true;

    this.checkListsService = checkListsService;
    this.checkListInstancesService = checkListInstancesService;
    this.loaderService = loaderService;
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;
    this.timeZoneId = Strings.DEFAULT_TIMEZONE;
    this.$modal = $modal;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$q = $q;

    var failedChecksPromise = (this.shopId ?
                                checkListInstancesService.getFailedChecksForShop(this.shopId) :
                                checkListInstancesService.getFailedChecksForPlant(this.plantId))
      .then(failedCheckLists => {
        this.failedCheckLists = _.filter(failedCheckLists, (instance) => checkListInstancesService.isAuthorizedForCurrentPlant(instance));
    });

    var promises = [ failedChecksPromise ];

    if (!_.isUndefined(this.shopId) && !_.isNull(this.shopId)) {
      promises.push(shopService.getShopConfiguration(this.shopId)
        .then(shop => {
          this.timeZoneId = shop.timeZoneId;
        }));
    }

    this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(
      this.plantId, this.shopId,
      (updated) => this.handleUpdated(updated),
      (instance) => this.handleInstance(instance));

    this.$scope.$on('$destroy', () => {
      if (this.hub) {
        this.hub.uninitialize();
      }
    });

    $q.all(promises).then(() => { this.loading = false; });
  }

  private handleUpdated(updated: apsEvents.CheckListInstancesUpdated) {
    if (!this.failedCheckLists) {
      return;
    }

    if (updated.instances.length > 0) {
      _.forEach(updated.instances, i => this.handleUpdated(i));
    }

    var existing = _.find(this.failedCheckLists, {id: updated.id});
    if (!existing) {
      return;
    }

    this.$timeout(() => {
      if (updated.action === apsEnums.EventAction.Delete
        || updated.result !== apsEnums.CheckListResult.Fail) {
        _.remove(this.failedCheckLists, existing);
      } else {
        existing.status = updated.status;
      }
    });
  }

  private handleNewInstance(instance: apsViewModels.CheckListInstanceItemEvent): boolean {
    if (instance.result !== apsEnums.CheckListResult.Fail || instance.checkListIsGroup) {
      return false;
    }

    this.failedCheckLists.push(instance);
    return true;
  }

  private handleInstance(instance: apsViewModels.CheckListInstanceItemEvent) {
    if (!this.failedCheckLists) {
      return;
    }

    if (instance.instances.length > 0) {
      _.forEach(instance.instances, i => this.handleInstance(i));
    }

    this.$timeout(() => {
      if (instance.action === apsEnums.EventAction.Add) {
        if (!this.handleNewInstance(instance)) {
          return;
        }
      } else {
        var existing = _.find(this.failedCheckLists, {id: instance.id});
        if (!existing) {
          if (!this.handleNewInstance(instance)) {
            return;
          }
        } else if (instance.result !== apsEnums.CheckListResult.Fail) {
          _.remove(this.failedCheckLists, existing);
        } else {
          existing.status = instance.status;
        }
      }
    });
  }

  formatTime(time) {
    return DateUtilityService.formatTimeOnly(time, this.timeZoneId);
  }

  open(checkListInstance: apsViewModels.CheckListInstanceListItem) {

    this.loaderService.loadingPromise(this.checkListsService
      .getCheckListReportDetail(checkListInstance.id, checkListInstance.plantLocationId,
        checkListInstance.scheduledOn, apsEnums.CheckListReportFilter.FailedOnly)
      .then( (detail: apsViewModels.CheckListInstanceReportDetail) => {
        openCheckListReportDetails({
          checkListInstance: detail.reportItem,
          detail: detail
        }, this.$modal);
      }));
  }
}

export default angular.module('aps.controller.failedChecks', requires)
  .controller('FailedChecksCtrl', FailedChecksCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/failedChecks.controller.ts